import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FONT_GSS_FUTURA } from 'themes/default';
import { resourceDarkGray } from 'styles/style-constants';
import { buildSearchQueryParams } from 'util/query-params-util';

const SupportLeftNavButton = ({ label, active }) => {
  const { smallBox, smallBoxSelected, selectedArrow } = useStyles();
  const navigate = useNavigate();
  const handleClick = () => navigate({ search: buildSearchQueryParams({ active: label }) });

  return (
    <div onClick={handleClick} className={clsx(smallBox, active && smallBoxSelected)}>
      {label}
      {active && <FontAwesomeIcon size="1x" className={selectedArrow} icon={faArrowRight} />}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  smallBox: {
    fontFace: FONT_GSS_FUTURA,
    color: '#000000',
    marginTop: 20,
    marginBottom: '5px',
    fontSize: '15px',
    fontWeight: 400,
    borderColor: '#DBDBDB',
    borderStyle: 'solid',
    borderRadius: '4px',
    borderWidth: '1px',
    paddingLeft: 10,
    paddingTop: 18,
    width: 248,
    height: 56
  },

  smallBoxSelected: {
    color: '#2878C1',
    boxShadow: '0px 4px 4px 0px' + resourceDarkGray
  },

  selectedArrow: {
    marginLeft: 12
  }
}));

export default SupportLeftNavButton;
